import { useMutation } from "react-query";
import http from "infra/http";
import { ManutencaoForm } from "../typings";
import { createFormData } from "infra/helpers/createFormData";
import { AxiosError } from "axios";

function useSaveManutencoes() {
  return useMutation<{ id: string }, AxiosError, ManutencaoForm>(
    async (form: ManutencaoForm) => {
      const formData = createFormData(
        form.files || [],
        form,
        "files",
        "arquivos"
      );

      const arquivosAntigosIds = form.files
        ?.filter((file) => !(file instanceof File))
        .map((file) => (file as { id: string }).id);

      if (form.id) {
        formData.append("oldFilesIds", JSON.stringify(arquivosAntigosIds));
        const { data } = await http.put<{ id: string }>(
          `/v1/manutencao/${form.id}`,
          formData
        );

        return data;
      }

      const { data } = await http.post(`/v1/manutencao`, formData);

      return data;
    },
    { retry: false }
  );
}

export default useSaveManutencoes;
